export const FETCH_START = "fetchStart";
export const FETCH_END = "fetchEnd";
export const SET_PLANS = "setPlans";